import React from "react";
import { useTranslation } from "react-i18next";
import {
	Box,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Typography,
} from "@mui/material";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";

import { getTranslation } from "../../utils/translation";

export default function DrawerMenu({ onSelect }) {
	const { i18n } = useTranslation();
	const navigate = useNavigate();

	const drawerItems = [
		{
			key: "downloadCsv",
			label: getTranslation(i18n, "adminDrawer.labels.downloadCsv"),
			icon: <InboxIcon />,
		},
	];

	const logout = () => {
		localStorage.removeItem("adminAccessToken");
		navigate("/onedot");
	};

	return (
		<Box
			sx={{
				width: "100%",
				height: "100%",
				display: "flex",
				flexDirection: "column",
			}}
			role="presentation"
		>
			{/* Sidebar Header */}
			<Box
				sx={{
					padding: "20px",
					borderBottom: "1px solid #e0e0e0",
					backgroundColor: "#f8f9fa",
				}}
			>
				<Typography
					variant="h6"
					sx={{
						fontWeight: 600,
						color: "#163a22",
						textAlign: "center",
					}}
				>
					{getTranslation(i18n, "adminDrawer.title")}
				</Typography>
			</Box>

			{/* Navigation Items */}
			<Box sx={{ flex: 1, paddingTop: "10px" }}>
				<List>
					{drawerItems.map((item) => (
						<ListItem key={item.key} disablePadding>
							<ListItemButton
								onClick={() => onSelect(item.key)}
								sx={{
									margin: "5px 10px",
									borderRadius: "8px",
									"&:hover": {
										backgroundColor: "#e8f5e8",
									},
								}}
							>
								<ListItemIcon sx={{ color: "#163a22" }}>
									{item.icon}
								</ListItemIcon>
								<ListItemText
									primary={item.label}
									sx={{ color: "#163a22" }}
								/>
							</ListItemButton>
						</ListItem>
					))}
				</List>
			</Box>

			{/* Logout Section */}
			<Box sx={{ borderTop: "1px solid #e0e0e0", padding: "10px" }}>
				<List>
					<ListItem key="logout" disablePadding>
						<ListItemButton
							onClick={logout}
							sx={{
								margin: "5px 10px",
								borderRadius: "8px",
								"&:hover": {
									backgroundColor: "#ffebee",
								},
							}}
						>
							<ListItemIcon sx={{ color: "#d32f2f" }}>
								<LogoutIcon />
							</ListItemIcon>
							<ListItemText
								primary={getTranslation(
									i18n,
									"adminDrawer.logout"
								)}
								sx={{ color: "#d32f2f" }}
							/>
						</ListItemButton>
					</ListItem>
				</List>
			</Box>
		</Box>
	);
}
